import { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { Link as Anchor } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { rgba } from 'polished';
import {
	List,
	FileText,
	Photo,
	Video,
	Microphone,
	Link
} from 'tabler-icons-react';
import { selectStyles } from 'Styles';
import { useStory } from 'Hooks';
import { Names, clx, isObjEmpty } from 'Utils';
import {
	ContentBox,
	StoryCard,
	ScrollBar,
	AddStoryCard,
	AddStoryMedia,
	AddStoryText,
	AddStoryLink
} from 'Elements';
import boxStyles from 'partials/dashboard/user-content.module.scss';
import styles from 'partials/dashboard/upload-content.module.scss';

export const UserUploadContent = () => {
	const { initStories } = useStory();
	const markers = useSelector((state) => state.marker);
	const [state, setState] = useState({
		selected_story: {},
		story: [],
		textCount: 0,
		imageCount: 0,
		videoCount: 0,
		soundCount: 0,
		linkCount: 0,
		dynamicAddBox: null,
		addBox: {
			text: AddStoryText,
			image: AddStoryMedia,
			video: AddStoryMedia,
			sound: AddStoryMedia,
			link: AddStoryLink
		}
	});

	const getStories = () => {
		const stories = [];
		markers.originList.map((marker) => {
			stories.push({
				value: marker.id,
				label: marker.title,
				item: marker
			});
		});
		return stories;
	};

	const handleSelect = (selected) => {
		setState((prev) => ({
			...prev,
			selected_story: selected
		}));
	};

	const addStory = (storyType) => {
		const rows = state.story;
		let typeCount = state[`${storyType}Count`];
		const count = typeCount + 1;

		const story_box = {
			type: storyType,
			uid: `story_${storyType}_${count}`
		};

		rows.push(story_box);
		setState((prev) => ({
			...prev,
			story: rows,
			[`${storyType}Count`]: count
		}));
	};

	const removeStory = (index, storyType) => {
		let rows = state.story;
		let typeCount = state[`${storyType}Count`];
		const count = typeCount - 1;
		const new_rows = rows.filter((e, i) => i !== index);

		setState((prev) => ({
			...prev,
			story: new_rows,
			[`${storyType}Count`]: count
		}));
	};

	const Menu = (props) => {
		return (
			<components.Menu {...props}>
				<ScrollBar
					className={styles.selectList}
					options={{
						className: 'os-theme-house',
						overflowBehavior: {
							x: 'hidden'
						},
						scrollbars: {
							autoHide: 'never',
							clickScrolling: true
						}
					}}>
					<components.MenuList {...props} />
				</ScrollBar>
			</components.Menu>
		);
	};

	const Option = (props) => {
		return (
			<components.Option {...props}>
				<span className={styles.ellipsis} title={props.label}>
					{props.children}
				</span>
			</components.Option>
		);
	};

	const NoOptionsMessage = (noOptopnProps) => {
		return (
			<components.NoOptionsMessage {...noOptopnProps}>
				<span className={styles.notfound}>هیچ روایتی پیدا نشد</span>
			</components.NoOptionsMessage>
		);
	};

	const renderLoadingMessage = () => {
		return (
			<div className={styles.loadingMessage}>
				در حال لود کردن روایت ها
			</div>
		);
	};

	const handleCloseStory = () => {
		setState((prev) => ({
			...prev,
			selected_story: {},
			story: [],
			textCount: 0,
			imageCount: 0,
			videoCount: 0,
			soundCount: 0,
			linkCount: 0
		}));
	};

	useEffect(() => {
		if (!markers.originList.length && isObjEmpty(state.selected_story)) {
			initStories();
		}
	}, [initStories, markers.originList, state.selected_story]);

	const customSelect = {
		...selectStyles,
		control: () => ({
			...selectStyles.control(),
			borderRadius: 10,
			border: 'none',
			boxShadow: `0 3px 6px ${rgba('#203696', 0.2)}`,
			transition: 'all 0.3s'
		}),
		menu: () => ({
			...selectStyles.menu(),
			borderRadius: 10,
			border: `1px solid ${rgba('#c9cdd9', 0.5)}`
		}),
		singleValue: () => ({
			...selectStyles.singleValue(),
			fontSize: '14px',
			color: ' #001727'
		}),
		option: () => ({
			...selectStyles.option(),
			overflow: 'hidden',
			':not(:last-child)': {
				borderBottom: `1px solid ${rgba('#c9cdd9', 0.5)}`
			}
		})
	};

	return (
		<div className={styles.content}>
			<ContentBox
				title="ارسال محتوا"
				icon={List}
				subtitle="روایت مورد نظر خود را جهت ارسال محتوا انتخاب کنید"
				headerButton={
					<Anchor
						to={Names.content.path}
						className={clx(
							boxStyles.headerSubmit,
							boxStyles.colorSubmit
						)}
						size="22">
						لیست محتوای ارسالی
					</Anchor>
				}>
				<div className="row">
					<div className="col-sm-6 mb-xs-15">
						<span className={styles.fieldsetLabel}>
							عنوان روایت
						</span>
						<Select
							isRtl
							placeholder=""
							closeMenuOnScroll
							styles={customSelect}
							value={state.selected_story}
							className={styles.fieldsetSelect}
							options={getStories()}
							loadingMessage={renderLoadingMessage()}
							components={{ Menu, NoOptionsMessage, Option }}
							onChange={handleSelect}
						/>
					</div>
					{!isObjEmpty(state.selected_story) && (
						<div className="col-sm-6">
							<StoryCard
								story={state.selected_story.item}
								onClose={handleCloseStory}
							/>
						</div>
					)}
				</div>
			</ContentBox>
			{!isObjEmpty(state.selected_story) && (
				<div className={styles.triggers}>
					<AddStoryCard
						title="افزودن متن"
						icon={FileText}
						onClick={() => addStory('text')}
					/>
					<AddStoryCard
						title="افزودن تصویر"
						icon={Photo}
						onClick={() => addStory('image')}
					/>
					<AddStoryCard
						title="افزودن ویدیو"
						icon={Video}
						onClick={() => addStory('video')}
					/>
					<AddStoryCard
						title="افزودن صوت"
						icon={Microphone}
						onClick={() => addStory('sound')}
					/>
					<AddStoryCard
						title="افزودن لینک"
						icon={Link}
						onClick={() => addStory('link')}
					/>
				</div>
			)}
			{state.story?.length > 0 &&
				state.story.map((story, idx) => {
					const StoryBox = state.addBox[story.type];
					return (
						<StoryBox
							key={story.uid}
							index={idx}
							type={story.type}
							storyId={state.selected_story?.item?.id}
							onAdd={addStory}
							onRemove={removeStory}
						/>
					);
				})}
		</div>
	);
};
